<i18n>
{
  "en":{
    "body": "?body=XRobotmon ID: {uid}%0D%0AXRobotmon email: {email}%0D%0A↑↑↑ [Please keep these account info so that we can provide timely response] ↑↑↑%0D%0A"
  },
  "zhHant":{
    "body": "?body=XRobotmon ID: {uid}%0D%0AXRobotmon email: {email}%0D%0A↑↑↑ [請保留以上資訊，以便團隊能更快速提供支援] ↑↑↑%0D%0A"
  },
  "ja":{
    "body": "?body=XRobotmon ID: {uid}%0D%0AXRobotmon email: {email}%0D%0A↑↑↑ [上記の情報は編集せずそのままお送りください。サポートが迅速に対応いたします。] ↑↑↑%0D%0A"
  },
  "ko":{
    "body": "?body=XRobotmon ID: {uid}%0D%0AXRobotmon email: {email}%0D%0A↑↑↑ [이상의 정보를 남겨서 팀이 더 빨리 지원할 수 있도록 해 주세요.] ↑↑↑%0D%0A"
  }
}
</i18n>
<template>
  <v-list class="transparent">
    <v-list-tile>
      <v-list-tile-action>
        <v-icon class="blue--text text--lighten-2">mdi-facebook-messenger</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>
          <a href="https://m.me/RobotmonOfficial" target="_blank" style="text-decoration: none">Facebook messenger </a>
        </v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile v-show="$i18n.locale === 'ja'">
      <v-list-tile-action></v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>
          <a
            href="https://mobile.twitter.com/messages/725931637716844548-1139404288222887937"
            target="_blank"
            style="text-decoration: none"
          >
            <v-icon>mdi-twitter</v-icon>&nbsp;X（旧Twitter）でメッセージを送る
          </a>
        </v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile>
      <v-list-tile-action>
        <v-icon class="blue--text text--lighten-2">mdi-email</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>
          <a
            v-bind:href="
              'mailto:XRobotmon@gmail.com' +
              (userProfile
                ? $i18n.t('body', {
                    uid: userProfile.uid,
                    email: userProfile.email,
                  })
                : '')
            "
            target="_blank"
            style="text-decoration: none"
            >XRobotmon@gmail.com</a
          >
        </v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</template>

<script>
import firebase from 'firebase/app';

export default {
  data: () => ({
    userProfile: null,
  }),
  created() {
    if (firebase.auth().currentUser) {
      this.$set(this, 'userProfile', firebase.auth().currentUser);
    }
  },
};
</script>
